import { set, get } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchInventoryItemsTemplateDownloadUrl } from '../../../sagas/routines';
import {
  toggleSidebarNav,
  toggleDropdownNavItem,
  resetDropdownNavItems,
  clearItemsTemplateDownloadUrl
} from '../../../actions';
import NAV_KEYS from '../../../../../components/inventory/PageLayout/nav-keys';

const initialState = {
  sidebarNavExpanded: true,
  dropdownNavItemsExpanded: {
    [NAV_KEYS.ITEMS]: false,
    [NAV_KEYS.PACKAGES]: false,
    [NAV_KEYS.REPORTS]: false
  },
  itemsTemplateDownloadUrl: '',
  fetchingItemsTemplateDownloadUrl: false
};

const fetchInventoryItemsTemplateDownloadUrlHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetchingItemsTemplateDownloadUrl: true
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('itemsTemplateDownloadUrl', response.presignedUrl, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingItemsTemplateDownloadUrl: false
  })
});

const clearItemsTemplateDownloadUrlHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    itemsTemplateDownloadUrl: ''
  })
});

const toggleSidbarNavHandler = action => ({
  [action.toString()]: ({ sidebarNavExpanded, ...state }) =>
    set('sidebarNavExpanded', !sidebarNavExpanded, state)
});

const toggleDropdownNavItemHandler = action => ({
  [action.toString()]: (
    { dropdownNavItemsExpanded, ...state },
    { payload: navItem }
  ) =>
    set(
      'dropdownNavItemsExpanded',
      {
        ...dropdownNavItemsExpanded,
        [navItem]: !get(navItem, dropdownNavItemsExpanded)
      },
      state
    )
});

const resetDropdownNavItemsHandler = action => ({
  [action.toString()]: set(
    'dropdownNavItemsExpanded',
    initialState.dropdownNavItemsExpanded
  )
});

export default createReducer(initialState, {
  ...toggleSidbarNavHandler(toggleSidebarNav),
  ...toggleDropdownNavItemHandler(toggleDropdownNavItem),
  ...resetDropdownNavItemsHandler(resetDropdownNavItems),
  ...fetchInventoryItemsTemplateDownloadUrlHandler(
    fetchInventoryItemsTemplateDownloadUrl
  ),
  ...clearItemsTemplateDownloadUrlHandler(clearItemsTemplateDownloadUrl)
});
